// extracted by mini-css-extract-plugin
export default {"filled-star":"Rating_filled-star__7ISKe"};